module.exports = __webpack_public_path__ + "static/media/therabot.820833de.png";